export default __webpack_public_path__ + "static/media/yatri-med-dark.e7e9d76e.svg";